module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Db-Ef.0fd4fe13.png";